// extracted by mini-css-extract-plugin
export default {"buttons":"nav_buttons__ijBrG","img":"nav_img__WGG1t"};